import { FC, useEffect, useState } from 'react'
import mclasses from '../../../../styles/modal.module.css'
import Modal from '@common/Modal'
import { crmApi } from '@/api'
import { useAddAlert } from '@/hooks/useAddAlert'
import { IcoRemove } from '@/utils/icons'
import Button from '@UI/New/Button'
import { LeadStatus } from '@/api/types/crm/crm.types'
import { isError } from '@/helpers/checkQuery'
import StatusItem from '../../blocks/StatusListBlock/StatusItem'

interface DeleteLeadStatusModalProps {
  status?: LeadStatus | null
  open: boolean
  onClose: () => void
  onSuccess?: () => void | Promise<void>
  // onDismiss: () => void
}

const DeleteLeadStatusModal: FC<DeleteLeadStatusModalProps> = ({
  status,
  open,
  onSuccess,
  onClose,
}) => {
  const addAlert = useAddAlert()
  const [isDeleting, setIsDeleting] = useState(false)

  useEffect(() => {
    if (!open) {
      setIsDeleting(false)
    }
  }, [open])

  const handleConfirm = async () => {
    if (!status || isDeleting) {
      if (!status) {
        addAlert({
          title: 'Ошибка',
          text: 'Не выбран статус',
          type: 'error',
        })
        onClose()
      }
      return
    }

    setIsDeleting(true)

    try {
      const res = await crmApi.deleteLeadStatus({
        status_history_id: status.id,
      })

      if (isError(res)) {
        throw new Error()
      }

      addAlert({
        title: 'Успешно',
        text: 'Успешно удалено',
        type: 'success',
      })
      await onSuccess?.()
    } catch {
      addAlert({
        title: 'Ошибка',
        text: 'Ошибка удаления статуса',
        type: 'error',
      })
      onClose()
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Modal
      active={open}
      className={mclasses.modalWrapper as any}
      setActive={() => onClose()}
    >
      <div className={mclasses.modalContainer}>
        <div className={mclasses.modalHeader}>
          <div className={mclasses.modalTitleContainer}>
            <span className={mclasses.modalHeaderTitle}>
              Вы уверены что хотите удалить?
            </span>
          </div>
          <div className={mclasses.closeIcon} onClick={() => onClose()}>
            <IcoRemove />
          </div>
        </div>
        <div className={mclasses.formWrapper}>
          {status && (
            <StatusItem leadStatus={status} size="large" />
          )}
        </div>
        <div className={mclasses.actions}>
          <Button
            color="gray"
            disabled={isDeleting}
            onClick={() => onClose()}
          >
            Отменить
          </Button>
          <Button
            color="primary"
            isLoading={isDeleting}
            disabled={isDeleting}
            onClick={() => handleConfirm()}
          >
            Подтвердить
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default DeleteLeadStatusModal
